import { VariableType } from 'json-to-graphql-query';
import type { FieldValue } from './types';

interface FireActionMutation {
  mutation: {
    __variables: {
      actionId: 'ID';
      actionType: 'String';
      payload: 'GenericScalar';
    };
    fireAction: {
      __args: {
        actionId: VariableType;
        actionType: VariableType;
        payload: VariableType;
      };
      response: FieldValue;
    };
  };
}

export const fireAction = (truify: boolean = false): FireActionMutation => ({
  mutation: {
    __variables: {
      actionId: 'ID',
      actionType: 'String',
      payload: 'GenericScalar',
    },
    fireAction: {
      __args: {
        actionId: new VariableType('actionId'),
        actionType: new VariableType('actionType'),
        payload: new VariableType('payload'),
      },
      response: truify,
    },
  },
});
